import { render, staticRenderFns } from "./SearchFormStats.vue?vue&type=template&id=1199b3d4&lang=pug&"
import script from "./SearchFormStats.vue?vue&type=script&lang=js&"
export * from "./SearchFormStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports